import React from 'react';
import Map from "./Components/Map.js"

import "./App.css";
import Navbar from './Components/Navbar.jsx';


function App() {
  return (
    <div className="App">
      <Navbar/>
     <Map/>
    </div>
  );
}

export default App;